import { Component, Input, OnInit } from '@angular/core';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
  selector: 'app-redirect-modal',
  templateUrl: './redirect-modal.component.html',
  styleUrls: ['./redirect-modal.component.scss'],
})
export class RedirectModalComponent implements OnInit {
  /**
   * This component receive an url and make the redirect after asking if user agree
   * 
   */

  @Input() urlRedirect: string = '';
  timer = null;

  constructor(
    private utilsService: UtilsService
  ) {
  }

  ngOnInit(): void {
    this.timer = setTimeout(() => {
      window.location.href = this.urlRedirect;
    }, 3000);
  }

  dismiss() {
    clearTimeout(this.timer);
    this.utilsService.dismissModal();
  }

}
